import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

const reloadUrl: string[] = ["/quick-info", "/quick-payment", "/quick-review"];

export const useReload = () => {
  const location = useLocation();

  const alertUser = useCallback(
    (e: any) => {
      const result = reloadUrl.filter((single) => {
        var reg = new RegExp(`.*${single}`);
        return location.pathname.match(reg);
      });

      if (result.length > 0) {
        e.preventDefault();
        e.returnValue = "You have some unsaved changes";
        return "You have some unsaved changes";
      }
    },
    [location]
  );

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, [alertUser]);
};
